import { IconProp } from "@fortawesome/fontawesome-svg-core";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import classnames from "classnames";

export const LBtn = ({ ...props }: ButtonProps): JSX.Element => {
    const margin = props.smallSpacing ? 1 : 6;
    const padding = props.smallSpacing ? 2 : 6;
    const classes = classnames(
        "button",
        props.notRounded ? "" : "is-rounded",
        !props.fullWidth && !props.noSpacing ? "px-" + padding.toString() : "",
        !props.fullWidth && !props.noSpacing ? "mx-" + margin.toString() : "",
        props.smallTopBottomMargins ? "small-height" : "",
        props.fullWidth ? "is-fullwidth" : "",
        props.verticalSpacing ? `my-${props.verticalSpacing}` : "",
        props.loading ? "is-loading" : "",
        props.isActive ? "is-active" : "",
        props.theme === "dark"
            ? "is-white is-outlined"
            : props.theme === "grey"
            ? "is-grey is-outlined"
            : props.variation === "unstyled"
            ? "is-ghost"
            : props.variation === "outline"
            ? "is-outlined is-primary"
            : props.variation === "select"
            ? "is-bordered"
            : "is-primary",
        props.isLarge ? "is-large" : "",
        props.isBold ? "has-text-weight-bold" : "",
        props.toolTipText ? "tooltip" : "",
        props.classes
    );

    return (
        <button
            className={classes}
            name={props.name}
            onClick={props.onClick}
            type={props.type ?? "button"}
            role="button"
            aria-label={props.ariaLabel}
            aria-haspopup={props.ariaPopup}
            aria-controls={props.ariaControls}
            disabled={props.disabled}
            form={props.form}
            style={{
                ...(props.disabled && props.variation === "unstyled" && { border: "none" }),
                ...(!!props.backgroundColor && { backgroundColor: props.backgroundColor })
            }}
            data-tooltip={props.toolTipText}
        >
            {props.toolTipText && <span className="tooltip-text">{props.toolTipText}</span>}
            {props.iconLeft && (
                <span className="icon">
                    <FontAwesomeIcon icon={props.iconLeft} />
                </span>
            )}
            <span className={props.fontSize ? `is-size-${props.fontSize}` : "is-size-6"}>{props.children}</span>
            {props.iconRight && (
                <span className="icon">
                    <FontAwesomeIcon icon={props.iconRight} />
                </span>
            )}
        </button>
    );
};

interface ButtonProps {
    children: React.ReactNode;
    inversed?: boolean;
    name?: string;
    onClick?: React.MouseEventHandler<HTMLButtonElement>;
    variation?: "" | "unstyled" | "outline" | "secondary" | "select";
    notRounded?: boolean;
    disabled?: boolean;
    loading?: boolean;
    noSpacing?: boolean;
    smallSpacing?: boolean;
    fullWidth?: boolean;
    type?: "submit" | "reset" | "button";
    verticalSpacing?: "0" | "1" | "2" | "3" | "4" | "5" | "6";
    ariaLabel?: string;
    theme?: "dark" | "light" | "grey";
    ariaPopup?: boolean;
    ariaControls?: string;
    isActive?: boolean;
    isBold?: boolean;
    form?: string;
    classes?: string;
    iconLeft?: IconProp;
    iconRight?: IconProp;
    smallTopBottomMargins?: boolean;
    isLarge?: boolean;
    fontSize?: "1" | "2" | "3" | "4" | "5" | "6" | "7" | "6h";
    backgroundColor?: string;
    toolTipText?: string | JSX.Element;
}
